import axios from "axios";

function getData(data) {
    return axios.post('api/cliente/dataTable', data);
}

function guardarCliente(data) {
    return axios.post('api/cliente/guardarCliente', data);
}

function editarCliente(data) {
    return axios.put('api/cliente/editarCliente', data);
}


export {
    getData,
    guardarCliente,
    editarCliente
}
